module.exports = __webpack_public_path__ + "img/cerrar-sesion.68b31186.svg";